import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Area } from '../../../services/content-api/content-api.service';
import { Observable, Subscription } from 'rxjs';
import { FronteggAuthService } from '@frontegg/angular';
import { ConfirmationService } from 'primeng/api';
import { UserPrivilegesService } from '../../../services/auth-privileges/auth-privileges.service';
import { Bind } from 'primeng/bind';
import { Button } from 'primeng/button';
import { BatchListComponent } from '../../../components/batch-list/batch-list.component';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-web-capture-batching',
  templateUrl: './web-capture-batching.component.html',
  styleUrls: ['./web-capture-batching.component.scss'],
  imports: [Bind, Button, BatchListComponent, AsyncPipe, TranslatePipe]
})
export class WebCaptureBatchingComponent implements OnInit {
  private fronteggAuthService = inject(FronteggAuthService);
  private router = inject(Router);
  private confirmationService = inject(ConfirmationService);
  private userPrivilegesService = inject(UserPrivilegesService);

  private subscription = new Subscription();

  hasUploadedFilesAtCreation: boolean = false;
  user?: any;
  tenantId: string = '';
  batchIdToCreate: string = '';
  areas: Area[] = [];

  /**
   *
   */
  ngOnInit(): void {
    this.tenantId = localStorage.getItem('tenantId') || '';
    const organization = localStorage.getItem('vanityName');

    if (this.tenantId && organization) {
      this.subscription.add(
        this.fronteggAuthService.authState$.subscribe(authState => {
          if (authState.user?.accessToken) {
            this.user = authState.user;
          }
        })
      );
    }
  }

  /**
   *
   */
  startBatchCreation() {
    this.router.navigate(['webcapture/batches/new']);
  }

  /**
   *
   * @param batchId
   */
  openBatch(batchId: string): void {
    this.router.navigate(['webcapture/batches/' + batchId]);
  }

  /**
   *
   * @param actionCode
   */
  canPerformAction(actionCode: string): Observable<boolean> {
    return this.userPrivilegesService.canPerformAction(actionCode);
  }
}
